//
//
//
//
//
//

export default {
  name: 'hamburger',
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    toggleClick: {
      type: Function,
      default: null
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Hamburger/index.vue